export default __webpack_public_path__ + "static/coffee-lab-bd38d89081f2e94630091a335bde0a07.gif";